import { render, staticRenderFns } from "./THeadTableTest.vue?vue&type=template&id=413da9e6&scoped=true"
import script from "./THeadTableTest.vue?vue&type=script&lang=js"
export * from "./THeadTableTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413da9e6",
  null
  
)

export default component.exports